(ns ^:no-doc frontend.handler.editor.lifecycle
  (:require [dommy.core :as dom]
            [frontend.db :as db]
            [frontend.handler.editor :as editor-handler]
            [frontend.state :as state]
            [frontend.util :as util]
            [goog.dom :as gdom]
            [logseq.shui.hooks :as hooks]))

(defn did-mount!
  [id config]
  (let [content (state/get-edit-content)
        input (state/get-input)
        node (util/rec-get-node input "ls-block")
        container-id (when node
                       (when-let [container-id-str (dom/attr node "containerid")]
                         (util/safe-parse-int container-id-str)))]
    (when input
      (when-not (:skip-focus? config)
        (.focus input)))
    (when container-id
      (state/set-state! :editor/container-id container-id))

    (when content
      (editor-handler/restore-cursor-pos! id content))

    (when-let [element (gdom/getElement id)]
      ;; TODO: check whether editor is visible, do less work
      (js/setTimeout #(util/scroll-editor-cursor element) 50))

    ;; skip recording editor info when undo or redo is still running
    (when-not (or (:skip-focus? config)
                  (contains? #{:undo :redo} @(:editor/op @state/state)))
      (when-let [edit-block-db-id (:db/id (state/get-edit-block))]
        (let [page-id (:block/uuid (:block/page (db/entity edit-block-db-id)))
              repo (state/get-current-repo)
              editor-info (state/get-editor-info)]
          (when page-id
            (state/<invoke-db-worker :thread-api/undo-redo-record-editor-info
                                     repo
                                     editor-info)))))
    (state/set-state! :editor/op nil)))

(defn use-did-mount!
  [id config]
  (hooks/use-layout-effect!
   #(did-mount! id config)
   []))
